import { LOGOUT_REQUEST } from '@sit/client-shared';
import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: [],
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getItemsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getItemsRequestFailure = (state, action) => {
  return {
    ...state,
    data: [],
    error: action.error,
    loading: false,
  };
};
const getItemsRequestSuccess = (state, payload) => {
  const data = payload.data.res;
  return {
    ...state,
    data,
    initialLoad: true,
    error: null,
    loading: false,
  };
};

const logoutRequest = () => initialState;

export default handleActions(
  {
    [types.GET_ITEMS_REQUEST]: getItemsRequest,
    [types.GET_ITEMS_REQUEST_FAILURE]: getItemsRequestFailure,
    [types.GET_ITEMS_REQUEST_SUCCESS]: getItemsRequestSuccess,
    [LOGOUT_REQUEST]: logoutRequest,
  },
  initialState,
);
